module.exports = __webpack_public_path__ + "img/LIGHTBOX-YAPO-BI.b663365c.jpg";